import { TransferTripType } from '../enums/transfer-trip-type.enum';
import { XpassTripTypeLabels } from '../enums/xpass-trip-type-labels.enum';

export class TransferTripTypeModel {
  public static TransferTripTypeList: Array<{ name: string; value: TransferTripType }> = [
    { name: XpassTripTypeLabels.ARRIVAL, value: TransferTripType.ArrivalOnlyTrip },
    { name: XpassTripTypeLabels.DEPARTURE, value: TransferTripType.DepartureOnlyTrip },
    { name: XpassTripTypeLabels.ROUND_TRIP, value: TransferTripType.RoundTrip }
  ];
}
